import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import * as React from 'react';
import PropTypes from 'prop-types';
import { sizes, sizeMap, useId } from './utils';

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21 12a9 9 0 01-9 9 9 9 0 01-9-9c0-4.969 4.03-9 9-9s9 4.031 9 9zm-8.758-6.024c-1.978 0-3.24.833-4.23 2.314a.436.436 0 00.098.59l1.26.954c.189.144.458.11.604-.077.649-.822 1.093-1.299 2.08-1.299.741 0 1.658.477 1.658 1.196 0 .544-.448.823-1.18 1.233-.854.479-1.984 1.075-1.984 2.565v.145c0 .24.195.435.436.435h2.032c.24 0 .436-.195.436-.435v-.049c0-1.033 3.019-1.075 3.019-3.87 0-2.105-2.184-3.702-4.23-3.702zm-.242 9c-.92 0-1.67.749-1.67 1.67 0 .92.75 1.668 1.67 1.668.92 0 1.67-.748 1.67-1.669 0-.92-.75-1.67-1.67-1.67z"
});

function Question(_ref) {
  var sizeProp = _ref.size,
      title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutPropertiesLoose(_ref, ["size", "title", "titleId"]);

  var size = sizeMap.get(sizeProp);
  titleId = useId(titleId);
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: size.width,
      height: size.height,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "#212429",
      "aria-labelledby": titleId
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", {
      id: titleId
    }, title) : null, _ref2)
  );
}

Question.sizes = sizes;
Question.defaultProps = {
  size: sizes.md
};
Question.propTypes = {
  size: PropTypes.oneOf([Question.sizes.xs, Question.sizes.sm, Question.sizes.md, Question.sizes.lg, Question.sizes.xl]),
  titleId: PropTypes.string,
  title: PropTypes.string.isRequired
};
export default Question;